<app-loader-item
  *ngIf="message$ | async as message"
  [msg]="message.msg"
  [transparent]="message.transparent"></app-loader-item>
